import { createFileRoute } from '@tanstack/react-router';
import { Domains } from '../../organisms/Domains';

export const Route = createFileRoute('/_authenticated/domains')({
  component: Domains,
});
